var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_430_",
    d: "M24.4,14.2H5.5c-0.9,0-1.6,0.7-1.6,1.6v8.7c0,0.9,0.7,1.6,1.6,1.6h18.9c0.9,0,1.6-0.7,1.6-1.6v-1.6v-1.6 v-1.6v-1.6v-2.4C26,14.9,25.3,14.2,24.4,14.2z M18.1,18.1h-5.5v-1.6h5.5V18.1z M11,18.1H5.5v-1.6H11V18.1z M5.5,19.7H11v1.6H5.5 V19.7z M12.6,19.7h5.5v1.6h-5.5V19.7z M5.5,24.4v-1.6H11v1.6H5.5z M12.6,24.4v-1.6h5.5v1.6H12.6z M24.4,24.4h-4.7v-1.6h4.7V24.4z  M24.4,21.3h-4.7v-1.6h4.7V21.3z M19.7,18.1v-1.6h4.7v1.6H19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_444_",
    d: "M16.5,9.8V7.5V5.9V2c0-0.9-0.7-1.6-1.6-1.6H1.6C0.7,0.4,0,1.1,0,2v7.9c0,0.9,0.7,1.6,1.6,1.6H15 C15.8,11.4,16.5,10.7,16.5,9.8z M15,9.8H9.5V7.5H15V9.8z M9.5,5.9V3.5H15v2.4H9.5z M1.6,3.5h6.3v2.4H1.6V3.5z M1.6,7.5h6.3v2.4H1.6 V7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_448_",
    d: "M18.2,7.9h3.3c0.3,0,1,0.1,1,0.5v1.8h-1.9l2.5,2.5l2.5-2.5h-1.5V8.4c0-1.2-1.1-2.1-2.6-2.1h-3.3 c-0.2,0-0.4,0.2-0.4,0.4v0.8C17.8,7.7,18,7.9,18.2,7.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListview);
export default __webpack_public_path__ + "static/media/Listview.d6e81a279c73efa6be186a5eb48950a0.svg";
export { ForwardRef as ReactComponent };